<loren-page-content>
  <mat-card-title>{{ "toolbar.devices" | transloco }}</mat-card-title>

  @if (devices$ | async; as devices) {
    @if (devices.length) {
      <div class="devices-all-table-scroll">
      <table mat-table [dataSource]="devices" class="devices-all-table">
        <ng-container matColumnDef="serialNumber">
          <th mat-header-cell *matHeaderCellDef>{{ "device.serial_number" | transloco }}</th>
          <td mat-cell *matCellDef="let device">{{ device.serialNumber || "-" }}</td>
        </ng-container>

        <ng-container matColumnDef="physicalAddress">
          <th mat-header-cell *matHeaderCellDef>{{ "device.physical_address" | transloco }}</th>
          <td mat-cell *matCellDef="let device">{{ device.physicalAddress || "-" }}</td>
        </ng-container>

        <ng-container matColumnDef="assetName">
          <th mat-header-cell *matHeaderCellDef>{{ "device.asset_name" | transloco }}</th>
          <td mat-cell *matCellDef="let device">{{ device.assetName || "-" }}</td>
        </ng-container>

        <ng-container matColumnDef="createdOn">
          <th mat-header-cell *matHeaderCellDef>{{ "device.created_on" | transloco }}</th>
          <td mat-cell *matCellDef="let device">{{ (device.createdOn | lorenDate) || "-" }}</td>
        </ng-container>

        <ng-container matColumnDef="lastActivityOn">
          <th mat-header-cell *matHeaderCellDef>{{ "device.last_activity_on" | transloco }}</th>
          <td mat-cell *matCellDef="let device">{{ (device.lastActivityOn | lorenDate) || "-" }}</td>
        </ng-container>

        <ng-container matColumnDef="batteryLevel">
          <th mat-header-cell *matHeaderCellDef>{{ "device.battery_level" | transloco }}</th>
          <td mat-cell *matCellDef="let device">
            <battery-level [deviceId]="device.id"></battery-level>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      </div>
    } @else {
      <p>{{ "asset.no_data" | transloco }}</p>
    }
  }
</loren-page-content>
